module.exports = __webpack_public_path__ + "img/30.c40ce28c.jpg";